import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfileWorkConditionRequest } from '@/shared/api/requests/club/working-condition/get/request';
import { getClubProfileWorkCondition } from '@/shared/api/requests/club/working-condition/get/request';

export const useClubProfileWorkConditionQuery = (
  params: GetClubProfileWorkConditionRequest,
  settings?: QuerySettings<typeof getClubProfileWorkCondition>
) =>
  useQuery({
    queryKey: ['ClubProfileWorkCondition', params.clubId],
    queryFn: () =>
      getClubProfileWorkCondition({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
